export default __webpack_public_path__ + "static/media/scdream8.e231d499.woff";